export type ActivatableLocation = {
  id: string
  isActive?: boolean
}

export function isInactiveLocation(location: ActivatableLocation): boolean {
  return location.isActive === false
}

export function visibleLocationOptions<T extends ActivatableLocation>(
  options: T[],
  isManager: boolean,
  keptIds: ReadonlySet<string>,
): T[] {
  if (isManager) return options
  return options.filter(
    (option) => !isInactiveLocation(option) || keptIds.has(option.id),
  )
}
